import React from 'react';
import {IThemeService} from './theme.service.interface';
import {OrbitTheme} from '../../themes/architecture/orbit-theme.interface';
import {action, observable} from 'mobx';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ServiceBase} from '../ServiceBase';


export class ThemeService extends ServiceBase implements IThemeService {

    constructor(services: IServiceFactoryExtended, theme: OrbitTheme) {
        super(services);
        this._setCurrentTheme(theme);
    }

    @observable.ref
    currentTheme: OrbitTheme = null;


    @action.bound
    private _setCurrentTheme(theme: OrbitTheme) {
        this.currentTheme = theme;
    }

    renderGlobalStyles(): React.ReactNode {
        return this.currentTheme.globalStyles;
    }

}

